import { RoundedCloseButton } from "../../Buttons/RoundedCloseButton/Index";
import { ButtonOnlyTitle } from "../../Buttons/ButtonOnlyTitle/Index";
import { useFilter } from "../../../hooks/useFilter";
import { Modal } from "../Default/Index";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import { useTranslation } from "react-i18next";

export const InventoryTaskStop = () => {
    const { t } = useTranslation();
    const { setModalInventoryTaskStop, modalInventoryTaskStop } = useFilter();
    const { setOptionForm } = useEditOnboarding();


    return (<>
        <div style={{ zIndex: 910 }}>
            <Modal
                visible={modalInventoryTaskStop}
                contentStyle={{
                    padding: "60px",
                    width: "433px",
                    height: "auto",
                    borderRadius: 25,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 30
                }}
            >
                <header className="success__modal-header">
                    <RoundedCloseButton onClick={() => setModalInventoryTaskStop(false)} />
                </header>
                <h2 className="dateTitle">{t("inventory.title")}</h2>
                <span>{t("inventory.stopTasksWarning")}</span>


                <footer className="buttons-container">
                    <ButtonOnlyTitle
                        title={t("inventory.back")}
                        theme="light"
                        onClick={() => {
                            setOptionForm(undefined)
                            setModalInventoryTaskStop(false)
                        }}
                    />
                    <ButtonOnlyTitle
                        title={t("inventory.next")}
                        theme="info"
                        onClick={() => {
                            setModalInventoryTaskStop(false)
                        }}
                    />
                </footer>
            </Modal>
        </div>
    </>)
}
